import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';
import { HelpCircle } from 'lucide-react';
import { API } from './constants';

export const FaqSection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/faq`).then(({ data }) => setItems(data.data)).catch(() => {}); }, []);
  if (items.length === 0) return null;
  return (
    <section className="py-20 bg-gradient-to-br from-slate-50 to-blue-50" data-testid="faq-section">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <span className="inline-flex items-center gap-2 text-sm font-semibold text-blue-600 bg-blue-100 rounded-full px-4 py-1.5 mb-4"><HelpCircle className="h-4 w-4" /> Preguntas frecuentes</span>
            <h3 className="text-4xl font-bold text-slate-900 mb-3">Resolvemos tus dudas</h3>
            <p className="text-lg text-slate-600">Todo lo que necesitas saber antes de contratar tu seguro de viaje.</p>
          </div>
          <div className="lg:col-span-3">
            <Accordion type="single" collapsible className="space-y-3">
              {items.map((f, i) => (
                <AccordionItem key={f.id} value={f.id} data-testid={`faq-item-${i}`} className="bg-white rounded-2xl border border-slate-100 px-6 shadow-sm data-[state=open]:shadow-lg transition-shadow">
                  <AccordionTrigger className="text-left font-semibold text-slate-800 hover:no-underline py-5">{f.pregunta}</AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed pb-5">{f.respuesta}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqSection;
